import { render, staticRenderFns } from "./training.modify.vue?vue&type=template&id=11474c47&scoped=true&"
import script from "./training.modify.vue?vue&type=script&lang=js&"
export * from "./training.modify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11474c47",
  null
  
)

export default component.exports